import { useFliptBoolean } from "@flipt-io/flipt-client-react";
import useUser from "~/contexts/user";

export const usePipelinesFlag = (): boolean => {
  const user = useUser();
  return useFliptBoolean("new-pipelines-ui", false, user?.email);
};

export const useBatchSubmissionFlag = () => {
  const user = useUser();
  return useFliptBoolean("workflow-batch-submission", false, user?.email);
};

export const useBatchSubmissionV2Flag = () => {
  const user = useUser();
  return useFliptBoolean("workflow-batch-submission-2", false, user?.email);
};

export const useNewSubmissionsPageFlag = () => {
  const user = useUser();
  return useFliptBoolean("new-submissions-page", false, user?.email);
};

export default usePipelinesFlag;
